import { render, staticRenderFns } from "./FormCheckboxMultiple.vue?vue&type=template&id=55aad078&"
import script from "./FormCheckboxMultiple.vue?vue&type=script&lang=js&"
export * from "./FormCheckboxMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports